module.exports = __webpack_public_path__ + "img/adobe-acrobat.7bcd625c.svg";